import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createImageBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/mediaBlockHelpers";
import {
  createButtonBlock,
  createH1Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import {
  DesignProp,
  GeneralProp,
  MarginsProp,
  PaddingsProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import { getBackgroundColorOptions } from "@circle-react-shared/BuilderUI/utils/buttonStyleHelpers";
import { getBorderRadiusOptions } from "@circle-react-shared/BuilderUI/utils/imgStyleHelpers";
import { getSizingOptions } from "@circle-react-shared/BuilderUI/utils/sizeStyleHelpers";
import { primaryBlockDefaultStyles } from "../constants";
import placeholderImage from "./homepage_block_1_default_image.png";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "HomepageBlock1",
  meta: {},
  props: {
    leftContent: {
      meta: {
        name: "Left Content",
        nameI18n: "builder_ui.prop_type.left_content",
      },
      prop: "children",
      type: "children",
      value: [
        createH1Block({
          text: "Lead with confidence. Grow with community.",
        }),
        createPBlock({
          text: "Your roadmap to leadership success: Expert coaching, a powerful peer network, and a system for sustained career growth. Get clarity, confidence, and support—starting today.",
        }),
      ],
    },
    rightContent: {
      meta: {
        name: "Right Content",
        nameI18n: "builder_ui.prop_type.right_content",
      },
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          placeholder: placeholderImage,
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                maxHeight: "none",
                maxWidth: "none",
                width: "100%",
                height: "33rem",
                minHeight: "auto",
                minWidth: "auto",
              },
            }),
            borderRadius: getBorderRadiusOptions({
              defaultValue: {
                border_left_top_radius: 20,
                border_left_bottom_radius: 20,
                border_right_top_radius: 20,
                border_right_bottom_radius: 20,
              },
            }),
          },
        }),
      ],
    },
    buttons: {
      meta: {
        name: "Buttons",
        nameI18n: "builder_ui.prop_type.buttons",
      },
      prop: "children",
      type: "children",
      value: [
        createButtonBlock({
          text: "Join the Community",
          href: "#",
        }),
        createButtonBlock({
          text: "Book a Consultation",
          buttonType: "secondaryButton",
          href: "#",
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        backgroundColor: getBackgroundColorOptions({
          defaultValue: primaryBlockDefaultStyles.backgroundColor,
          category: [DesignProp, GeneralProp],
        }),
        padding: getPaddingOptions({
          defaultValue: primaryBlockDefaultStyles.padding,
          category: [DesignProp, PaddingsProp],
        }),
        margin: getMarginOptions({
          defaultValue: primaryBlockDefaultStyles.margin,
          category: [DesignProp, MarginsProp],
        }),
      },
      meta: {
        name: "Styles",
        nameI18n: "builder_ui.prop_type.styles",
        category: [],
      },
    },
  },
};
